import * as React from "react";

const IconPaginationSmallDown: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7">
            <polygon
                fill="currentColor"
                points="2.503 3.502 3.025 2.976 7.934 -1.974 8.456 -2.5 9.497 -1.448 8.975 -.922 4.585 3.502 8.978 7.925 9.5 8.451 8.456 9.5 7.934 8.974 3.022 4.027 2.5 3.502"
                transform="matrix(0 -1 -1 0 9.5 9.5)"
            />
        </svg>
    );
};

export default React.memo(IconPaginationSmallDown);
